export default {
  getCompletedTaskComment: (state) => state.completedTaskComment,
};
